/*
 * Description: Multi language drop down component,
 * Author: Chris
 * CreatedAt: 2021-3-10
 */

import React from 'react';

import css from './MultiLangDropDown.less';

import { IMAGE_URL } from 'src/tools/constant';

interface IProps {
  title: string;
  className?: Record<string, unknown>;
}

const MultiLangDropDown = ({ title, className }: IProps) => {
  return (
    <div className={`${css.mldContainer} ${className}`}>
      <span className={css.mldTitle}>{title}</span>
      <img
        alt='icon'
        src={`${IMAGE_URL}icon/drop-down.svg`}
        className={css.mldIcon}
      />
    </div>
  );
};

export default MultiLangDropDown;
